import React, { FunctionComponent, useReducer, useEffect } from 'react';
import Loading from '@justgiving/loading';
import robot from './assets/robot.il.svg';
import clientConfig from '../../client/config';

const JG_LOGO =
  'https://images.justgiving.com/image/f468c25c-93e5-4e2d-bcb9-eb525559fb43.jpg';

type QRImgProps = {
  url: string;
};

export const QRImg: FunctionComponent<QRImgProps> = ({ url }) => {
  const reducer = (state: any, action: any) => {
    switch (action.type) {
      case 'IMAGELOADED':
        return { ...state, isLoading: false, hasError: false };
      case 'IMAGEERRORED':
        return { ...state, isLoading: false, hasError: true };
      default:
        throw new Error();
    }
  };

  const [state, dispatch] = useReducer(reducer, {
    isLoading: true,
    hasError: false,
    src: `${clientConfig.qrCodeUrl}/qr?url=${encodeURIComponent(
      url,
    )}&logoUrl=${encodeURIComponent(JG_LOGO)}`,
  });

  useEffect(() => {
    const img = new Image();

    img.src = state.src;

    img.onload = () => {
      dispatch({ type: 'IMAGELOADED' });
    };

    img.onerror = () => {
      dispatch({ type: 'IMAGEERRORED' });
    };
  }, [state.src]);

  if (state.isLoading) {
    return (
      <div className="jg-space-mvlg" data-qa="loading-wrapper">
        <Loading size="medium" />
      </div>
    );
  }

  if (state.hasError) {
    return <img src={robot} alt="Error icon" data-qa="error-svg" />;
  }

  return <img src={state.src} alt="QR code" data-qa="qr-code" />;
};

export default QRImg;
